import { log } from '../../app/logger.js';
import { PipeableArray } from './pipeable_array.js';
import { AsyncDataPipeableMixin } from './async_data_pipeable_mixin.js';

class AsyncDataPipeableArray extends AsyncDataPipeableMixin(PipeableArray) {
  set(list) {
    log(
      `[data] ${this.dataClassName} set: ${list
        ?.map(f => f.toString())
        .join(', ')}`
    );
    super.set(list);
  }
}

export { AsyncDataPipeableArray };
